import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import App from './App.vue'
import { useCookies } from 'vue3-cookies'
import 'element-plus/dist/index.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import router from './components/router/index'
import store from './components/store/store'
import 'dayjs/locale/ru'
import ru from 'element-plus/es/locale/lang/ru'
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
import dayjs from 'dayjs'
import '@/assets/theme.css'
import '@/assets/appointment-modal.css'
import '@/assets/settings-theme.css'
import axios from 'axios'
import { installGlobalErrorHandlers, reportApiFailure, reportFrontendError } from '@/services/monitoring'

library.add(fas, far, fab);

dayjs.locale({
  ...dayjs.Ls.ru,
  weekStart: 1
})

axios.interceptors.response.use(
  response => response,
  error => {
    const response = error?.response
    if (!response || response.status >= 500) {
      reportApiFailure({
        url: response?.config?.url || error?.config?.url || window.location.href,
        method: response?.config?.method || error?.config?.method || 'GET',
        statusCode: response?.status || 0,
        message: error?.message || 'axios_request_failed',
        requestId: response?.headers?.['x-request-id'] || '',
        responseBody: typeof response?.data === 'string' ? response.data : '',
      })
    }
    return Promise.reject(error)
  }
)

const app = createApp(App)
app.config.errorHandler = (error, instance, info) => {
  reportFrontendError({
    category: 'vue_runtime',
    severity: 'error',
    message: error?.message || info || 'vue_runtime_error',
    stack: error?.stack || '',
    extra: {
      info,
      component: instance?.$options?.name || instance?.$?.type?.name || '',
    },
  })
}

installGlobalErrorHandlers(router)

app
  .use(ElementPlus, {
    locale: ru
  })
  .use(useCookies)
  .use(VueTelInput)
  .use(router)
  .use(store)
  .component('font-awesome-icon', FontAwesomeIcon)
  .mount('#app')
